const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_IS_LOADING': {
            return { ...state, isLoading: action.payload };
        }
        case 'SET_IS_LOADING_MORE': {
            return { ...state, isLoadingMore: action.payload };
        }
        case 'TOGGLE_CHAT_LIST': {
            return { ...state, showChatList: action.payload };
        }
        case 'SET_CHAT_ROOMS': {
            return { ...state, chatRooms: action.payload };
        }
        case 'SET_ACTIVE_CHAT_ROOM':{
            return { ...state, activeChatRoom: action.payload };
        }
        case 'ADD_NEW_CHAT_ROOM': {
            return { ...state, chatRooms: [action.payload, ...state.chatRooms] };
        }
        case 'SET_IS_SENDING': {
            return { ...state, isSending: action.payload };
        }
        default:
            return state;
    }
};

export default reducer;
